export enum RouteName {
  DirectToCustomerWelcome = "Direct_To_Customer_Welcome",
  DirectToCustomerOfferSummary = "Direct_To_Customer_OfferSummary",
  DirectToCustomerTermsAndConditions = "Direct_To_Customer_TermsAndConditions",
  M3AddOns = "M3_AddOns",
  M3CXWaitValidationView = "M3_CX_Wait_ValidationView",
  M3CartVerification = "M3_CartVerification",
  M3ClerkLogin = "M3_ClerkLogin",
  M3Complete = "M3_Complete",
  M3Contract = "M3_Contract",
  M3CreateSalesClerk = "M3_CreateSalesClerk",
  M3CreditCheckPermissionView = "M3_CreditCheckPermissionView",
  M3CustomerContactInfoView = "M3_CustomerContactInfoView",
  M3CustomerDeclinedValidation = "M3_CustomerDeclinedValidation",
  M3CustomerRegistration = "M3_CustomerRegistration",
  M3DeviceLogin = "M3_DeviceLogin",
  M3DeviceRepairList = "M3_DeviceRepairList",
  M3DeviceRepairProcess = "M3_DeviceRepairProcess",
  M3Ecommerce = "M3_Ecommerce",
  M3EcommerceDownPaymentPaid = "M3_Ecommerce_Down_Payment_Paid",
  M3EcommerceSummary = "M3_EcommerceSummary",
  M3EcommerceSelectDownpaymentType = "M3_EcommerceSelectDownpaymentType",
  M3EcommerceCashInStoreDownpayment = "M3_EcommerceCashInStoreDownpayment",
  M3EcommerceOpenPayDownPayment = "M3_EcommerceOpenPayDownPayment",
  M3EcommerceOpenPayDownPaymentAltUi = "M3_EcommerceOpenPayDownPaymentAltUi",
  M3EcommercePartnerDownPayment = "M3_EcommercePartnerDownPayment",
  M3EcommercePixDownPayment = "M3_EcommercePixDownPayment",
  M3ElectronicDownPaymentStatus = "M3_ElectronicDownPaymentStatus",
  M3EnrollDevice = "M3_Enroll_Device",
  M3ExternalIdUploader = "M3_ExternalIdUploader",
  M3FaceLogin = "M3_FaceLogin",
  M3FaceLoginIncodeCapture = "M3_FaceLoginIncodeCapture",
  M3Help = "M3_Help",
  M3IdentificationUploader = "M3_IdentificationUploader",
  M3Imei = "M3_Imei",
  M3IncodeCaptureBackAndSelfie = "M3_IncodeCaptureBackAndSelfie",
  M3IncodeCaptureFront = "M3_IncodeCaptureFront",
  M3IncodeIntroduction = "M3_IncodeIntroduction",
  M3IncodeWebFlow = "M3_IncodeWebFlow",
  M3LatestReceipts = "M3_LatestReceipts",
  M3MerchantLogin = "M3_MerchantLogin",
  M3MerchantPaymentReceipt = "M3_MerchantPaymentReceipt",
  M3MerchantSaleReceipt = "M3_MerchantSaleReceipt",
  M3Offers = "M3_Offers",
  M3PaymentsInquery = "M3_Payments_Inquery",
  M3PaymentsInqueryResult = "M3_Payments_Inquery_Result",
  M3PaymentsReceipt = "M3_Payments_Receipt",
  M3PostOfferRegistration = "M3_PostOfferRegistration",
  M3PreRegistrationOffers = "M3_PreRegistrationOffers",
  M3PurchaseConfirmation = "M3_PurchaseConfirmation",
  M3QRLogin = "M3_QRLogin",
  M3QrLanding = "M3QrLanding",
  M3QrLoginIncodeCapture = "M3_QrLoginIncodeCapture",
  M3RMerchantRecreatePassword = "M3R_MerchantRecreatePassword",
  M3RMerchantRequestResetPassword = "M3R_MerchantRequestResetPassword",
  M3Receipt = "M3_Receipt",
  M3RegisterClerk = "M3_RegisterClerk",
  M3RejectedOfferEcommerce = "M3_RejectedOfferEcommerce",
  M3SelfOnboardingAskCxCall = "M3SelfOnboardingAskCxCall",
  M3SelfOnboardingCartDetails = "M3_SelfOnboardingCartDetails",
  M3SelfOnboardingGetValidCart = "M3_SelfOnboardingGetValidCart",
  M3SelfOnboardingInstructions = "M3_SelfOnboardingInstructions",
  M3SelfOnboardingSummary = "M3_SelfOnboardingSummary",
  M3Software = "M3_Software",
  M3SoftwareInstallFailed = "M3_SoftwareInstallFailed",
  M3SpeedMoney = "M3_SpeedMoney",
  M3SupportedModels = "M3_SupportedModels",
  M3TakeASelfieIntro = "M3_TakeASelfieIntro",
  M3TermsAndConditions = "M3_TermsAndConditions",
  M3Welcome = "M3_Welcome",
  M3EcommerceFinishedSale = "M3_EcommerceFinishedSale",
  M3PreparingOffersV2 = "M3_PreparingOffersV2",
  M3SelectingOffersV2 = "M3_SelectingOffersV2",
  M3ConfigurablePolicy = "M3ConfigurablePolicy",
  M3ConfigurableKyc = "M3ConfigurableKyc",
  M3ConfigurableCustomerContactInfo = "M3ConfigurableCustomerContactInfo",
  M3ConfigurableCreditCheck = "M3ConfigurableCreditCheck",
  M3ConfigurableDob = "M3ConfigurableDob",
  M3ConfigurableOffers = "M3ConfigurableOffers",
  M3ConfigurableOffersV2 = "M3ConfigurableOffersV2",
  M3ConfigurableIdNumberDob = "M3ConfigurableIdNumberDob",
  M3DateOfBirthVerification = "M3_DateOfBirthVerification",
  M3IdNumberDobVerification = "M3_IdNumberDobVerification",
}
